import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { StageConfig, DEFAULT_STAGE_CONFIG } from './stage-definitions';

/**
 * Hook that returns the current stage configuration from the Redux store.
 * This ensures that updated stage definitions saved via the StageDefinition component
 * are immediately reflected in the metrics and analytics.
 */
export function useCurrentStageConfig(): StageConfig {
  const stageConfig = useSelector((state: RootState) => state.stageConfig.stage_config);
  return stageConfig ?? DEFAULT_STAGE_CONFIG;
} 